import {SWITCH_LANGUAGE} from "../../constants/ActionTypes";
import {
  LAYOUT_TYPE,
  LAYOUT_TYPE_FULL,
  NAV_STYLE,
  NAV_STYLE_DEFAULT_HORIZONTAL,
  THEME_COLOR,
  THEME_TYPE,
  THEME_TYPE_SEMI_DARK, UPDATE_RTL_STATUS
} from "../../constants/ThemeSetting";

const LOCAL_STORAGE_KEYS = {
  LOCALE: "locale-v2",
}
//TODO: WHERE TO GET THAT WHOLE THING BEFORE WE GET INTO THIS?

let savedLocaleString = window.localStorage.getItem(LOCAL_STORAGE_KEYS.LOCALE)

if(!savedLocaleString || savedLocaleString === "undefined") {
  window.localStorage.setItem(LOCAL_STORAGE_KEYS.LOCALE, JSON.stringify({
    languageId: "english",
    locale: "en",
    name: "English",
    icon: "gb",
  }));
}
savedLocaleString = window.localStorage.getItem(LOCAL_STORAGE_KEYS.LOCALE)

const locale = JSON.parse(savedLocaleString)


const initialSettings = {
  navStyle: NAV_STYLE_DEFAULT_HORIZONTAL,
  layoutType: LAYOUT_TYPE_FULL,
  themeType: THEME_TYPE_SEMI_DARK,
  themeColor: '',

  isDirectionRTL: false,
  locale,
};

const SettingsReducer = (state = initialSettings, action) => {
  switch (action.type) {

    case THEME_TYPE:
      return {
        ...state,
        themeType: action.themeType
      };
    case THEME_COLOR:
      return {
        ...state,
        themeColor: action.themeColor
      };

    case UPDATE_RTL_STATUS:
      return {
        ...state,
        isDirectionRTL: action.rtlStatus
      };

    case NAV_STYLE:
      return {
        ...state,
        navStyle: action.navStyle
      };
    case LAYOUT_TYPE:
      return {
        ...state,
        layoutType: action.layoutType
      };

    case SWITCH_LANGUAGE:
      window.localStorage.setItem(LOCAL_STORAGE_KEYS.LOCALE, JSON.stringify(action.payload));
      return {
        ...state,
        locale: action.payload,
      };
    default:
      return state;
  }
};

export default SettingsReducer;
